import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { FiCalendar } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";
import "./datePicker.css";

const MoneyballDatePicker = ({
  selected,
  onChange,
  maxDate,
  minDate,
  active = false,
  variant = "header",
  ariaLabel = "Choose date",
  ...props
}) => (
  <DatePicker
    selected={selected}
    onChange={onChange}
    maxDate={maxDate}
    minDate={minDate}
    dateFormat="yyyy-MM-dd"
    withPortal
    closeOnSelect
    calendarClassName="moneyball-datepicker"
    portalId="moneyball-datepicker-portal"
    wrapperClassName={variant === "filter" ? "moneyball-datepicker-trigger moneyball-datepicker-trigger--full" : "moneyball-datepicker-trigger"}
    customInput={
      <DateTrigger variant={variant} active={active} ariaLabel={ariaLabel} />
    }
    {...props}
  />
);

const DateTrigger = forwardRef(
  ({ value, onClick, active, variant, ariaLabel }, ref) => {
    const isFilter = variant === "filter";
    const className = isFilter
      ? `flex min-h-[48px] w-full items-center justify-center gap-1.5 rounded-lg px-2 py-1 font-sans text-[11px] transition ${
          active
            ? "bg-white text-header_green shadow-md"
            : "text-white/60 hover:bg-white/10 hover:text-white"
        }`
      : "flex h-10 items-center gap-1.5 rounded-lg border border-white/10 bg-white/10 px-2.5 font-sans text-[10px] text-white/75 transition hover:bg-white/20 hover:text-white active:scale-95";

    return (
      <button
        type="button"
        ref={ref}
        onClick={onClick}
        aria-label={`${ariaLabel}, currently ${value}`}
        className={className}
      >
        <FiCalendar className="h-4 w-4 flex-none" />
        <span className={isFilter ? "" : "hidden xs:inline"}>{value}</span>
      </button>
    );
  }
);

DateTrigger.displayName = "DateTrigger";

export default MoneyballDatePicker;
